import {
    useCallback,
    useEffect,
    useState,
} from "react";

import {
    DARK_THEME,
    readThemePreference,
    saveThemePreference,
} from "./theme-preference";
import {
    browserThemePreference,
} from "../../infrastructure/theme/browser-theme-preference";

export function useThemePreference() {
    const [theme, setThemeState] = useState(() =>
        readThemePreference({
            themePreferenceRepository:
            browserThemePreference,
        })
    );

    useEffect(() => {
        browserThemePreference.apply(theme);
    }, [theme]);

    const setTheme = useCallback((nextTheme) => {
        const savedTheme = saveThemePreference({
            theme: nextTheme,
            themePreferenceRepository:
            browserThemePreference,
        });

        setThemeState(savedTheme);
    }, []);

    return {
        theme,
        isDarkTheme: theme === DARK_THEME,
        setTheme,
    };
}